import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

export default function HotProducts() {
  const { t } = useTranslation();
  const hotProducts = products.filter((p) => p.isHot).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('hotProducts')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            {t('hotProductsDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {hotProducts.map((product) => (
            <Link
              key={product.id}
              to={`/category?tab=${product.categoryId}`}
              className="group bg-background-50 rounded-lg overflow-hidden hover:bg-background-100 transition-all duration-500"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  {product.isNew && (
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">新品</span>
                  )}
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {product.categoryId === 'beauty' ? '美妆护肤' : product.categoryId === 'food' ? '食品零食' : product.categoryId === 'home' ? '家居日用' : product.categoryId === 'health' ? '健康保健' : product.categoryId === 'fashion' ? '服饰配饰' : product.categoryId === 'baby' ? '母婴用品' : '数码电器'}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-300 line-clamp-1">
                  {product.name}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {product.description}
                </p>
                <p className="text-base font-bold text-primary-600">
                  {product.price}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            {t('heroCTA')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}